<style lang="less" scoped>
.container-div {}

.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    width: 120px;
    white-space: nowrap;

    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    // min-width: 260px;
    width: 100%;
    text-align: right;
    margin-left: 20px;
  }

}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}
</style>

<template>
  <div class="detail-content-div">
    <!-- 调试信息面板 -->
    <div v-if="!detailForm.custNo" style="background: #f0f0f0; padding: 10px; margin: 10px; border-radius: 4px;">
      <h4>调试信息:</h4>
      <p>Store中的客户数据: {{ JSON.stringify($store.state.custObj) }}</p>
      <p>详情表单数据: {{ JSON.stringify(detailForm) }}</p>
    </div>
    
    <el-row :gutter="30">
      <div class="title-div">客户信息</div>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">客户编号</div>
        <div>{{ detailForm.custNo || '暂无数据' }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">注册日期</div>
        <div>{{ detailForm.registerTime || '暂无数据' }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">手机号</div>
        <!-- <div>{{ detailForm.mobile }}</div> -->
        <div class="cust-detail-value" style="display: flex;justify-content: center;">
          <span style="margin-right: 8px" v-if="isFlag">{{
            detailForm.mobile
              ? detailForm.mobile
              : "-"
          }}</span>
          <span style="margin-right: 8px" v-else>
            {{
              detailForm.mobile
                ? detailForm.mobile.replace(
                  detailForm.mobile.substring(2, 9),
                  "*******"
                )
                : "-"
            }}
          </span>
          <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_隐藏.png" alt=""
            v-if="isFlag == false" @click="flagChange()" />
          <img style="width: 20px; height: 20px" src="../../../assets/app-card-style/眼睛_显示.png" alt=""
            v-if="isFlag == true" @click="flagChange()" />
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">注册渠道</div>
        <div>{{ detailForm.registerSourceName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">用户昵称</div>
        <div>{{ detailForm.custName }}</div>
      </el-col>
      <!-- <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">生日</div>
        <div>{{ detailForm.birthday }}</div>
      </el-col> -->
      <!-- <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">性别</div>
        <div>{{ detailForm.sex }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">地址</div>
        <div>{{ detailForm.custAddr }}</div>
      </el-col> -->
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">累计充电次数</div>
        <div>{{ detailForm.totalChargeTimes }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">累计充电量</div>
        <div>{{ detailForm.totalCount }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">最近登录时间</div>
        <div>{{ detailForm.loginTime }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">最近充电时间</div>
        <div>{{ detailForm.latestChargeDate }}</div>
      </el-col>
      <!-- <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex">
        <div class="cust-detail-title">共享充电限制</div>
        <div style="color:#4182EB">{{ detailForm.firstChargeDate }}</div>
      </el-col> -->
      <el-col :xs="24" :sm="24" :md="24" :lg="24" class="flex" style="font-weight: 600;font-size: 18px;" v-if="detailForm.custType !== '共享充电账号'">实名信息</el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex" v-if="detailForm.custType !== '共享充电账号'">
        <div class="cust-detail-title">用户真实姓名</div>
        <div>{{ detailForm.custRealName }}</div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" class="flex" v-if="detailForm.custType !== '共享充电账号'">
        <div class="cust-detail-title">用户真实身份证号</div>
        <div style="color:#4182EB">{{ detailForm.certNo }}</div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="24" class="flex" style="font-weight: 600;font-size: 18px;" v-if="0">激活账单</el-col>
      <el-table :data="tableData" style="width: 100%" border stripe v-if="0">
        <el-table-column prop="totalFee" label="购买订单编号" width="200" align="center" />
        <el-table-column prop="pileCodes" label="用户手机号" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买类型" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买名称" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买内容" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买金额" width="200" align="center" />
        <el-table-column prop="pileCodes" label="购买时间" width="200" align="center" />
        <el-table-column prop="pileCodes" label="支付方式" width="200" align="center" />
        <el-table-column prop="pileCodes" label="交易流水号" width="200" align="center" />
      </el-table>
      <div class="list-pagination" v-if="0">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
      <el-col :span='24' class="text-right">
        <button class="common-empty-button" @click="back()">返 回</button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      isFlag: false,
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      chargeData: [],
      selections: [], // 表格选项
      pagination: pageConfig.detailPagination,
      editFlag: false,
      pageTitle: '客户详情',
      // 默认值设置
      detailForm: {},
      custDto: {}, //未使用
      queryInfo: {}, // 默认内容
      dialogForm: {
        //度电设置弹窗内容
        remark: '',
        chargeValue: '',
      },
      activeName: 'first', //默认激活状态
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          {
            id: 'remark',
            label: '备注',
            type: 'primary',
            show: true,
            disabled: false,
            method: (index, row) => {
              this.openRemark(row)
            },
          },
        ],
      }, // 列操作按钮

      caroperates: {
        width: 220,
        fixed: 'right',
        list: []
      },
      dialogFormVisible: false, //未使用(已删除功能)
      thirdDialogFormVisible: false, //度电设置弹窗
      dialogTitle: '', //未使用(已删除功能)
      dialogLabel: '', //未使用(已删除功能)
      actInExpAmount: '', //未使用(已删除功能)
      recentInTime: '暂无充值记录', //未使用(已删除功能)
      totalChargeValue: '', //累计度电
      chargeBalanceValue: '', //剩余度电
      tipFlag: false, //度电设置弹窗错误提示语
      btnUse: false, //判断是否可以点击确定按钮
      remarkShow: true, //客户备注内容是否显示
      inputShow: false, //备注内容输入框
      btnShow: true, //备注内容编辑按钮
      editShow: false, //备注内容保存按钮
      remarkDialogFormVisible: false, //备注信息弹窗
      dialogRemarkForm: {
        //备注信息表单内容
        remark: '',
      },
      mobileLength: '', //手机号码位数

      // 车辆信息数据
      carInfoTable: [],
      carPagination: pageConfig.carPagination
    }
  },
  methods: {
    flagChange() {
      this.isFlag = !this.isFlag;
    },
    init() {
      
      console.log("客户详情页面初始化，store中的客户数据:", this.$store.state.custObj); // 调试日志
      if (this.$store.state.custObj) {
        this.detailForm = this.$store.state.custObj
        console.log("设置详情表单数据:", this.detailForm); // 调试日志
        // this.getFormInfo()
      } else {
        console.error("未找到客户数据，请先选择客户"); // 错误日志
        this.$U.error("未找到客户数据，请先选择客户");
        // 延迟一下再跳转，给用户看到错误信息的时间
        setTimeout(() => {
          this.back();
        }, 2000);
      }
    },
    back() {
      this.$router.push({
        name: "custList"
      })
    },

  },
  mounted() {
    this.init()
  },
  watch: {
    '$store.state.custObj': {
      handler(newVal) {
        if (newVal) {
          console.log('监听到客户数据变化:', newVal);
          this.detailForm = newVal;
        }
      },
      immediate: true,
      deep: true
    }
  },
}
</script>
